import { Timestamp } from "firebase/firestore";
import { _createQrCodesConverter, _createPasscodeConverter, _createOrganizationConverter, _createOrganizationsAndCustomersConverter, _createPublicConfigConverter, _createUserConverter, _createInvitedConverter, _createPrivateConfigConverter, _createMimboxConverter, } from "../internal/implementations.js";
export const qrCodesConverter = _createQrCodesConverter(Timestamp);
export const passcodeConverter = _createPasscodeConverter(Timestamp);
export const organizationConverter = _createOrganizationConverter(Timestamp);
export const organizationsAndCustomersConverter = _createOrganizationsAndCustomersConverter();
export const publicConfigConverter = _createPublicConfigConverter();
export const privateConfigConverter = _createPrivateConfigConverter();
export const userConverter = _createUserConverter(Timestamp);
export const invitedConverter = _createInvitedConverter(Timestamp);
export const mimboxConverter = _createMimboxConverter();
//# sourceMappingURL=frontend.js.map